/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import templateOnly from '@ember/component/template-only';

export type ActionTab = 'tasks' | 'assignment-rules' | 'changeover-settings';

interface IArgs {
  active: ActionTab;
  tasksCount?: number;
}

interface UiActionTabsComponentSignature {
  Element: HTMLDivElement;

  Args: IArgs;
}

const UiActionTabsComponent = templateOnly<UiActionTabsComponentSignature>();

export default UiActionTabsComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Action::Tabs': typeof UiActionTabsComponent;
  }
}
